import { translateText } from "../../../helpers/LanguageHelper";
import React from "react";
import { Row, Col, Container, Media } from "reactstrap";
import myImage from '../../../resources/custom/images/call_img.png';

const ContactBanner = () => {
  return (
    <>
      <section className="contact-banner">
        <Container>
          <Row>
            <Col>
              <div className="contact-banner-contain">
                <div className="contact-banner-img">
                  <Media src={myImage} className="img-fluid" alt={translateText("call-banner")} />
                </div>
                <div>
                  <h3>{translateText("if you have any question please call us")}</h3>
                </div>
                <div>
                  <h2><a className="ukl-contact-banner-text" href="tel:6380413953">+91 63804 13953</a></h2>
                  <h6 className="ukl-contact-banner-text">{translateText("Directly buy from Uthukuli to Doorstep")}</h6>
                  
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default ContactBanner;
